(function (window) {
	"use strict";
	function definePageTitleHelper() {
		var pageTitleHelper = {};
		var portalPageTitle = document.getElementById("portalPageTitle");
		pageTitleHelper.setPageTitle = function(title){
			portalPageTitle.innerHTML = title + " - TalbotAnalytics";
		};
		return pageTitleHelper;
	}
	//define globally if it doesn't already exist
	if (typeof (pageTitleHelper) === "undefined") {
		window.pageTitleHelper = definePageTitleHelper();
	} else {
		console.log("pageTitleHelper already defined.");
	}
})(window);